// extracted by mini-css-extract-plugin
module.exports = {"prodImage":"active-product_prodImage__1utYi","prodName":"active-product_prodName__3oZQi","custombadge":"active-product_custombadge__1KSty"};